import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

interface BrutalButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  variant?: 'primary' | 'outline';
  className?: string;
  type?: 'button' | 'submit';
}

const BrutalButton: React.FC<BrutalButtonProps> = ({ 
  children, 
  onClick, 
  href,
  variant = 'primary',
  className = '',
  type = 'button'
}) => {
  const navigate = useNavigate();
  const isPrimary = variant === 'primary';

  const handleClick = () => {
    if (href) {
      navigate(href);
      window.scrollTo(0, 0);
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <motion.button
      type={type}
      whileHover={{ scale: 1.02, x: 3, y: -3 }}
      whileTap={{ scale: 0.98, x: 0, y: 0 }}
      onClick={handleClick}
      className={`
        group relative px-8 py-4 font-mono font-bold uppercase tracking-widest text-sm
        border-2 transition-all duration-150 cursor-pointer
        ${isPrimary 
          ? 'bg-brand-red text-black border-brand-red hover:bg-black hover:text-brand-red' 
          : 'bg-transparent text-brand-red border-brand-red/50 hover:border-brand-red hover:bg-brand-red/5'
        }
        ${className}
      `}
    >
      {/* Corner accents */}
      <div className={`absolute top-0 right-0 -mr-1.5 -mt-1.5 w-1.5 h-1.5 transition-colors duration-150 ${isPrimary ? 'bg-brand-white group-hover:bg-brand-red' : 'bg-brand-red/50 group-hover:bg-brand-red'}`} />
      <div className={`absolute bottom-0 left-0 -ml-1.5 -mb-1.5 w-1.5 h-1.5 transition-colors duration-150 ${isPrimary ? 'bg-brand-white group-hover:bg-brand-red' : 'bg-brand-red/50 group-hover:bg-brand-red'}`} />
      {children}
    </motion.button>
  );
};

export default BrutalButton;
